import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Input, message } from 'antd';
import { finish2ndPrize } from '../../redux/actions/4DCollection/finish4D';
import { toggle2ndPrizeFinishModal } from '../../redux/actions/4DCollection/toggleFinish4DModal';

class Finish2ndPrizeModal extends React.Component {
      constructor(props) {
            super(props);
            this.form = React.createRef();
      }
      onFinish = async (values) => {
            await this.props.onFinish({ id: this.props.result?.secondPrize?.id, ...values }, this.props.token);
            if (this.props.message) {
                  message.success(this.props.message);
                  this.props.onClose();
            }
            if (this.props.error) {
                  message.error(this.props.error);
            }
      }
      onFinishFailed = (errors) => {
            console.log(errors)
      }
      handleCancel = () => {
            this.props.onClose();
      }
      render() {
            const number = this.props.result?.secondPrize?.number;
            return (
                  <Modal
                        title="Finish 2nd Prize"
                        key="finish-2ndp-modal"
                        centered
                        visible={this.props.visible}
                        okButtonProps={{ form: 'finish-2ndp-form', key: 'submit', htmlType: 'submit' }}
                        confirmLoading={this.props.loading}
                        onCancel={this.handleCancel}
                        okText="Save"
                        loading={this.props.loading}
                  >
                        <Form
                              key={number+"form"}
                              layout="vertical"
                              ref={this.form}
                              id="finish-2ndp-form"
                              name="basic"
                              onFinish={this.onFinish}
                              onFinishFailed={this.onFinishFailed}>

                              <Form.Item
                                    key={number}
                                    name="number"
                                    label="Prize Number"
                                    rules={[
                                          {
                                                required: true,
                                                message: 'Require!',
                                          },
                                          {
                                                pattern: new RegExp(`^${number}$`),
                                                message: "Need to confirm the prize"
                                          }
                                    ]}>
                                    <Input />
                              </Form.Item>
                        </Form>
                  </Modal>
            );
      }
}

const mapStateToProps = state => ({
      visible: state.fourDCollection.finish2ndPrizeVisible,
      loading: state.fourDCollection.loading,
      token: state.auth.token,
      error: state.fourDCollection.error,
      message: state.fourDCollection.message,
      result: state.fourDCollection.result
})

const mapDispatchToProps = dispatch => ({
      onFinish: (obj, token) => dispatch(finish2ndPrize(obj, token)),
      onClose: () => dispatch(toggle2ndPrizeFinishModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Finish2ndPrizeModal);